import React, { Component } from 'react';
import { GenericEditPanel, GenericInputValidate } from 'com-gyf-webcore-userinterfacecomponents';

class DestinatarioReportes extends Component {
    constructor(props) {
        super(props);

        this.actualizarNovedadEstado = this.actualizarNovedadEstado.bind(this);
        this.changeInput = this.changeInput.bind(this);
    }
    /**
     * 
     * @param {any} novedad
     * @param {any} estadoId
     * @param {any} entidadId
     */
    actualizarNovedadEstado(novedad, estadoId, entidadId) {
        this.props.actualizarNovedadEstado(novedad.Id, estadoId, this.props.codigoNovedad, novedad.NovedadTipoId, entidadId)
    }
    /**
     * 
     * @param {any} event
     */
    changeInput(event) {
        this.props.changeInput(0, this.props.codigoNovedad, event.target.value);
    }
    /**
     * 
     */
    render() {
        let me = this;
        let props = this.props;
        let errors;
        const { getFieldProps, getFieldError } = props.form;
        let errorContainer;

        errorContainer = <label className="error">
            {(errors = getFieldError('inputDestinatarioReportes')) ? errors.join(',') : null}</label>

        let error = (getFieldError('inputDestinatarioReportes')) ? true : false

        //////////Novedad en Destinatario Reportes////////////
        let seEstaEditando = props.data.seEstaEditando;
        let descripcion = undefined;
        let novedadDestinatarioReportes = undefined;
        if (props.data.novedadesEmpresaDatos != undefined) {
            novedadDestinatarioReportes = props.data.novedadesEmpresaDatos.find(x => x.NovedadCampoCodigo == this.props.codigoNovedad);
            if (novedadDestinatarioReportes != undefined) {
                let esNovedadEditadaDestinatario = props.data.esNovedadEditada.find(x => x.campoCodigo == this.props.codigoNovedad).editado;
                if (esNovedadEditadaDestinatario) {
                    descripcion = props.data.empresaDatos.DestinatarioReportes;
                }
                else {
                    descripcion = novedadDestinatarioReportes.ValorNovedad;
                }
            }
            else {
                descripcion = props.data.empresaDatos.DestinatarioReportes;
            }
        } else {
            descripcion = props.data.empresaDatos.DestinatarioReportes;
        }
        ////////////////////////////////////////////////////

        let componenteDestinatarioReportes = <div>
            <GenericInputValidate
                getFieldProps={getFieldProps('inputDestinatarioReportes', {
                    onChange(e) {
                        me.changeInput(e);
                    },
                    rules: [{
                        required: true,
                        pattern: /^[ñA-Za-z\s]+$/,
                        message: 'Debe ingresar un destinatario válido.'
                    }]
                })}
                id="inputDestinatarioReportes"
                name="inputDestinatarioReportes"
                value={descripcion}
                className="form-control default-input"
                maxLength="40"
                autoComplete="off"
            />
            {errorContainer}
        </div>
        
        return (
            <GenericEditPanel
                componente={componenteDestinatarioReportes}
                permisoUsuario={props.data.funcionesDelUsuario}
                error={error}
                novedad={novedadDestinatarioReportes}
                seEstaEditando={seEstaEditando}
                textPanel={descripcion || "Sin especificar"}
                title="Destinatario de los reportes"
                value={descripcion}

                aceptChanges={(value) => this.props.guardarNovedad(value)}
                confirmarNovedad={() => this.actualizarNovedadEstado(novedadDestinatarioReportes, 2, props.data.empresaDatos.Id)}
                changeEditMode={(value) => this.props.estadoEdicion(value, this.props.codigoNovedad)}
                denegarNovedad={() => this.actualizarNovedadEstado(novedadDestinatarioReportes, 3, props.data.empresaDatos.Id)}
                mostrarModificaciones={this.props.mostrarModal}
                revert={this.props.cancelar}
            />
        );
    }
}

export default DestinatarioReportes;